import { FormNumberField, IFormNumberFieldProps } from './form-number-field';
import { Box } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import './form-number-input-adornment-field.scss';
// ✅ Custom event type with target.value
type EventWithValue = {
  target: {
    value: string | number;
  };
};

export interface IFormNumberInputAdornmentFieldProps
  extends Omit<IFormNumberFieldProps, 'onBlur'> {
  adornmentPosition?: 'start' | 'end';
  adornmentText: string;
  placeholder?: string;
  paddingLeft?: string;
  marginRight?: string;
  onBlur?: (e: EventWithValue) => void;
}

export const FormNumberInputAdornmentField: FC<
  IFormNumberInputAdornmentFieldProps
> = ({
  adornmentPosition = 'start',
  adornmentText,
  placeholder,
  paddingLeft,
  onBlur,
  name,
  marginRight,
  ...otherProps
}) => {
  const { getValues } = useFormContext();

  return (
    <FormNumberField
      {...otherProps}
      name={name}
      placeholder={placeholder}
      onBlur={() => {
        if (onBlur) {
          const value = getValues(name);
          const syntheticEvent: EventWithValue = {
            target: { value },
          };
          onBlur(syntheticEvent);
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position={adornmentPosition}
            sx={{ marginRight: `${marginRight ? marginRight : '1px'}` }}
          >
            <Box
              style={{
                fontSize: '14px',
                fontWeight: adornmentText === '%' ? 700 : 600,
                marginLeft: '10px',
                color: otherProps.disabled ? 'rgba(0, 0, 0, 0.4)' : 'black',
                paddingLeft: paddingLeft ?? '',
              }}
            >
              <Box>{adornmentText}</Box>
            </Box>
          </InputAdornment>
        ),
      }}
    />
  );
};
